export default __webpack_public_path__ + "static/media/math-icon-3-5.fc50a60ef2d33db0b0bf5072d4c1e801.svg";